// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___93d90598c109a1f24b6","cls2":"Unibrow-cls2___eea3f26ff72849431ff Unibrow-cls1___93d90598c109a1f24b6"};